"use client";

import { useTranslations } from "next-intl";
import CaloriesCalculatorIllustration from "@/assets/icons/calories-calculator.svg";

export const CaloriesCalculatorResultStep = ({
  result,
}: {
  result: number;
}) => {
  const t = useTranslations("calories-calculator");

  return (
    <div className="space-y-6">
      <div className="flex flex-col items-center gap-2 text-center">
        <CaloriesCalculatorIllustration
          aria-hidden="true"
          className="size-31"
        />
        <p className="font-medium text-base">{t("result.subheader")}</p>
        <p className="font-bold text-3xl">
          {t("result.value", { value: result })}
        </p>
      </div>
      <p className="text-base">{t("result.description")}</p>
    </div>
  );
};
